import { Modal } from '@didi/driver-biz-ui'
import { linkAuthorizationManagement } from '@/common/biz/link-authorization-management'
import store from '@didi/store'
import { PAGE_URL } from '@/common/biz/constants'

const year = new Date().getFullYear()
const month = new Date().getMonth()

const storeKey = `reauthorize_modal_${year}_${month}_count`

export function showReauthorizeModal(productLine: number, isAuto = false): Promise<boolean> {
  // empty
  const promise: Promise<boolean> = new Promise((resolve, reject) => {
    const count = Number(store.get(storeKey)) || 0
    if (isAuto && count === 3) return Promise.reject(new Error('fail close'))
    isAuto && store.set(storeKey, count + 1)
    Modal.$create({
      content: `
        <p>司机师傅：</p>
        <p style="text-indent: 2em">您已取消授权，当前无法享受医疗保障的平台补贴。为了您能享受补贴并成功投保，需要您重新签约授权。</p>
      `,
      direction: 'horizontal',
      confirmBtn: '重新授权',
      cancelBtn: '暂不考虑',
      onConfirm: () => {
        linkAuthorizationManagement({
          jumpUrl: `${PAGE_URL}/index.html?entry=home`,
          failJumpUrl: `${PAGE_URL}/index.html?entry=home&failGrant=true`,
          productLine: productLine
        })
      },
      onClose: () => {
        reject(new Error('fail close'))
      },
      onCancel: () => {
        reject(new Error('fail cancel'))
      }
      // eslint-disable-next-line
      // @ts-ignore
    }, (h) => {
      return h('img', {
        style: {
          width: '140px',
          'margin-bottom': '10px'
        },
        attrs: {
          src: 'https://dpubstatic.udache.com/static/dpubimg/B5wrDG1NXY4B63qOse4Gv.png'
        },
        slot: 'icon'
      }, 1)
    }).show()
  })
  return promise
}
